<div class="block-progress-container">
  <div class="progress-blocks">
    <div 
      *ngFor="let block of blocks; trackBy: trackByIndex" 
      class="progress-block"
      [class.filled]="block.filled"
      [class.empty]="!block.filled"
      [class.completed]="block.isCompletedBlock"
      [class.selected]="block.isSelectedBlock">
    </div>
  </div>
  <div class="progress-info" *ngIf="showLabel">
    <span class="progress-text">{{completedQValue}}/{{maxValue}}</span>
    <span class="progress-percentage">{{progressPercentage | number:'1.0-0'}}%</span>
  </div>
</div>
